export default function WhyGlorib() {
  const features = [
    {
      number: '01',
      title: '국내 우수 제조 인프라',
      description: 'ISO 인증을 받은 최신 설비와 청정 생산 환경을 갖춘 제조 시설'
    },
    {
      number: '02',
      title: '협력 네트워크',
      description: '검증된 원료 공급사 및 제조 파트너와의 긴밀한 협력 체계'
    },
    {
      number: '03',
      title: '안정적 생산 시스템',
      description: '소량 생산부터 대량 생산까지 유연하게 대응하는 생산 능력'
    },
    {
      number: '04',
      title: '체계적 개발 프로세스',
      description: '시장 조사부터 제품 출시까지 단계별 관리 시스템'
    },
    {
      number: '05',
      title: '화장품-덴탈케어 통합 생산',
      description: '뷰티와 오랄케어를 아우르는 종합 생산 역량'
    },
    {
      number: '06',
      title: '전략적 제휴 네트워크',
      description: '칫솔·치약 전문 공장과의 파트너십으로 확장된 제품 포트폴리오'
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Left Title */}
          <div className="lg:col-span-4">
            <h2 className="font-serif text-5xl lg:text-6xl font-bold text-gray-900 leading-tight sticky top-32">
              WHY<br />
              GLORIVE
            </h2>
          </div>

          {/* Right Grid */}
          <div className="lg:col-span-8">
            <div className="grid md:grid-cols-2 gap-6">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="group p-8 border border-gray-200 rounded-xl hover:bg-amber-50 hover:border-amber-200 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 cursor-pointer"
                >
                  <div className="text-4xl font-serif font-bold text-amber-700/20 group-hover:text-amber-700/40 transition-colors mb-4">
                    {feature.number}
                  </div>
                  
                  <h3 className="text-lg font-bold text-gray-900 mb-3 group-hover:text-amber-800 transition-colors">
                    {feature.title}
                  </h3>
                  
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
